import { Patient } from '../patient/patient';

export class Prescription {
  constructor(
    public id?: number,
    public date?: Date,
    public text?: string,
    public patient?: Patient
  ) {}
}
